import $ from 'jquery'

export default class navMain {
    constructor(element) {
        this.nav = element;
        this.$element = $(element);
        this.navItemsWithChildren = element.querySelectorAll(':scope > .nav-item:has(a.hasChildren)');

        // Event Listeners
        this.nav.addEventListener('keydown', this.handleMenuKeyDown.bind(this))
        this.nav.addEventListener('keyup', this.handleMenuKeyUp.bind(this))

        // Hover and Click EventHandlers
        this.navItemsWithChildren.forEach(item => {
            item.addEventListener('mouseenter', (e) => this.handleMouseEnter(e, item));
            item.addEventListener('mouseleave', this.handleMouseLeave.bind(this));

            const toggles = item.querySelectorAll(':scope > a, :scope > button');
            toggles.forEach(toggle => {
                toggle.addEventListener('click', (e) => this.handleMenuitemClick(e, item));
            })
        })
    }

    handleMenuitemClick(event, item) {
        event.preventDefault();
        this.toggleItem(item);
    }

    handleMouseEnter(event, item) {
        // Hide Others if not already hidden
        // Show Current
        this.hideAllSubmenus();
        this.showItem(item);
    }

    handleMouseLeave() {
        // Hide all
        this.hideAllSubmenus();
    }

    handleMenuKeyDown(event) {
        const {code, target} = event || {};

        if (!code) {
            return;
        }

        if (code === 'Space' || code === 'Enter') {
            this.handleKeySpace(event, target);
        }

        // Escape
        // if menu open -> close
        if (code === 'Escape') {
            this.handleKeyEscape(target)
        }
    }

    handleMenuKeyUp(event) {
        const {code, target} = event || {};

        if (code !== 'Tab') {
            return;
        }

        // Hide Submenu when navigating to different NavMain item
        const parent = target?.parentNode;
        const grandparent = parent?.parentNode;

        if (!parent?.classList.contains('navMain') && !grandparent?.classList.contains('navMain')) {
            return;
        }

        this.hideAllSubmenus();
    }

    handleKeySpace(event, target) {
        // TODO: fix and check if there is url?

        // Check if is nav-link or toggle.??
        if ((target.classList.contains('hasChildren') &&
            target.classList.contains('nav-link')) ||
          target.classList.contains('submenu-toggle')) {
            const parent = target.parentNode;
            if (!parent) {
                return;
            }
            // Check if nav-link is languageSwitch
            if (parent.parentNode?.classList.contains('languageSwitch')) {
                return;
            }
            event.preventDefault();
            this.toggleItem(parent);
        }
    }

    handleKeyEscape(target) {
        this.hideAllSubmenus();
        target.closest('.nav-item:has(>.nav-link-head)')?.querySelector('.nav-link-head')?.focus()
    }

    // Show Current
    showItem(item) {
        item.classList.add('open');
    }

    // Hide Current
    hideItem(item) {
        item.classList.remove('open');
    }

    // toggle Current?
    toggleItem(item) {
        if (!item.classList.contains('nav-item')) {
            return;
        }
        if (item.classList.contains('open')) {
            this.hideItem(item);
        } else {
            this.showItem(item);
        }
    }

    // Hide All
    hideAllSubmenus() {
        this.navItemsWithChildren.forEach(item => {
            this.hideItem(item);
        })
    }

    destroy() {
        // remove all eventhandlers on destroy ?
    }
}
